module.exports = __webpack_public_path__ + "static/img/identification-and-wayfinding.6cfd28a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/identification-and-wayfinding.jpg
// module id = 408
// module chunks = 0